import React from 'react';
import './Footer.css';

export default function (props) {
  return (
    <footer className="main-footer" role="contentinfo">
      <p className="copyright-text">&copy; <a href="https://terrancecorley.com" target="_blank" rel="noopener noreferrer">Terrance Corley 2018</a>.</p>
    </footer>
  )
}


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js